<template>
  <div data-testid="component-selector">
    <slot name="mobile" v-if="isMobile" />
    <slot name="desktop" v-if="!isMobile" />
  </div>
</template>

<script>
export default {
  name: 'selector',
  data: () => ({
    isMobile: window.innerWidth <= 991
  }),
  methods: {
    reportWindowSize() {
      const innerWidth = window.innerWidth
      innerWidth <= 991 ? (this.isMobile = true) : (this.isMobile = false)
    }
  },
  mounted() {
    window.addEventListener('resize', this.reportWindowSize)
  }
}
</script>
